import { Link } from "react-router";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useMessagingStore } from "@/stores/messaging-store";
import { toInbox } from "@/lib/urls";

export function MessagingBell() {
  const unread = useMessagingStore((s) => s.unreadCount);

  return (
    <Button
      asChild
      variant="ghost"
      size="sm"
      className="relative shrink-0 min-w-touch min-h-touch p-2"
    >
      <Link
        to={toInbox()}
        aria-label={`Messages${unread ? `, ${unread} unread` : ""}`}
      >
        <MessageSquare className="h-4 w-4 sm:h-5 sm:w-5" />
        {unread > 0 && (
          <span className="absolute -top-0.5 -right-0.5 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold rounded-full text-primary-foreground bg-primary">
            {unread > 99 ? "99+" : unread}
          </span>
        )}
        <span className="sr-only">Messages</span>
      </Link>
    </Button>
  );
}
